module.exports = __webpack_public_path__ + "static/img/stage-4.88f9301a.png";